import React from 'react';

const BASE_URL = 'https://testseries.world';
const examIds = ['jee-main', 'jee-advanced', 'neet', 'bitsat', 'nda', 'viteee'];

const generateSitemap = () => {
    const today = new Date().toISOString().split('T')[0];
    const examPages = examIds.map(exam => `
  <url>
    <loc>${BASE_URL}/mock-tests/${exam}</loc>
    <lastmod>${today}</lastmod>
    <priority>0.80</priority>
  </url>
  <url>
    <loc>${BASE_URL}/practice/${exam}</loc>
    <lastmod>${today}</lastmod>
    <priority>0.80</priority>
  </url>`).join('');

    return `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  <url>
    <loc>${BASE_URL}/</loc>
    <lastmod>${today}</lastmod>
    <priority>1.00</priority>
  </url>${examPages}
</urlset>`;
};

export const Sitemap = () => {
  const sitemapContent = generateSitemap();
  return (
    <pre style={{ whiteSpace: 'pre', fontFamily: 'monospace', padding: '1rem', color: '#212121', backgroundColor: '#FAFAFA', margin: 0, height: '100vh' }}>
      {sitemapContent}
    </pre>
  );
};